__turbopack_context__.v({
  "policy_togglebtn_wrapper": "CM92EG_policy_togglebtn_wrapper",
  "toggle_btn": "CM92EG_toggle_btn",
});
